
export const SET_USER_DATA  = "SET_USER_DATA";
export const CLEAR_USER_DATA = "CLEAR_USER_DATA";